import { render, staticRenderFns } from "./workerClueAddFormNew.vue?vue&type=template&id=0bae3e22&scoped=true"
import script from "./workerClueAddFormNew.vue?vue&type=script&lang=js"
export * from "./workerClueAddFormNew.vue?vue&type=script&lang=js"
import style0 from "./workerClueAddFormNew.vue?vue&type=style&index=0&id=0bae3e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae3e22",
  null
  
)

export default component.exports